export interface EvaluacionesInterface {
    idTramite:number;
    idRequisito:number;
    evalNombre:string;
    nombreItem:string;
    completado:boolean;
    estado:boolean;
    observacion:string;
    idSolicitud:number;
    idProyecto:number;
    idSolicitudEval:number;
    idSolicitudEvalDet?:number;
    editando?: boolean; // propiedad opcional para editar la fila de la tabla
}

export interface EvalInterface {
    idProyecto:number;
    idSolicitud:number;
    idEstado:number;
    usuario:string;
    fasesTramites?:FasesTramites[];
    id?:number;
}
export interface FasesTramites {
    idFase:number;
    idsTramites:number[];
}

export interface RevisionUsuarioInterface {
    usuario:string;
    uniqueIdUsuario:string;
    idRequisito:number;
    idTramite:number;
    completado:boolean;
    observacion:string;
    idSolicitudEval:number;
    idSolicitudEvalDet?:number;
}
export interface SolicitudEvalDocInterface {
    creadoPor: string;
    idSolicitud: number;
    idUsuario: string;
    opinionTecnica: string;
    idEvaluacion: number | null;
    tipo:number;
}
export interface SolicitudEvalDocTipoInterface {
    numeroExpediente: string;
    idSolicitud: number;
    fechaCreacion: string;
    opinionTecnica: string;
    uniqueIdUsuario: string;
    idEvaluacion: number | null;
    estado: number;
    idSolicitudEvalDoc:number;
}

export interface SolicitudEvalTramiteFase {
    nombreFase: string;
    orden: number;
    completada:boolean;
    tramitesEvalResponse:TramiteEvaluacion[];
    idFase:number;
}
export interface TramiteEvaluacion {
    codigoInstitucion: string;
    nombreInstitucion: string;
    idTramite: number;
    nombreTramite: string;
    idFase: number;
    nombreFase: string;
    idProyecto: number;
    idSolicitud: number;
    idEstadoTramite:number
    orden:number;
    completada:number;
    estadoEval:number;
}

export interface EvaluacionesSolicitudInterface {
    idSolicitudEval:number;
    idSolicitud:number;
    idProyecto:number;
    idFase:number;
    estado:boolean;
    fechaInicio:string;
    fechaFin:string;
}

export interface FasesEval {
    nombreFase: string;
    idFase:number;
}
export interface AvisosObservaciones {
    lectura: number;
    fechaCreacion: string;
    usuario: string;
    titulo: string;
    idSolicitudEval:number;
    idSolicitud:number;
    idSolicitudEvalAviso:number;
}
export const enum EvaluacionTipo {
    DocumentalyLegal = 1,
    Tecnica = 2
}
export const enum EvaluacionEstado {
    Pendiente = 1,
    EnProceso = 2,
    Finalizada = 3
}

export enum EvaluacionEstadosControl {
    Evaluacion=1,
    Observaciones = 2,
    Dictamen = 3,
    Resolucion  =4
}
